import { DRAFT_WIZARD_STEPS } from "@/types/drafting";

export function getDraftStepHref(matterId: string | undefined, step: number): string | undefined {
  if (!matterId) return undefined;
  switch (step) {
    case 1:
      return `/drafting/new?matterId=${matterId}`;
    case 2:
      return `/drafting/new?matterId=${matterId}&step=2`;
    case 3:
      return `/drafting/${matterId}`;
    case 4:
      return `/drafting/${matterId}/review`;
    case 5:
      return `/drafting/${matterId}/export`;
    default:
      return undefined;
  }
}

function isPreDraftWizardStatus(status?: string): boolean {
  return status === "setup" || status === "background";
}

export function getDraftStepNav(
  matterId: string,
  currentStep: number,
  options?: { matterStatus?: string }
) {
  const previousStep = DRAFT_WIZARD_STEPS.find((step) => step.id === currentStep - 1);
  const nextStep = DRAFT_WIZARD_STEPS.find((step) => step.id === currentStep + 1);

  let previousHref = getDraftStepHref(matterId, currentStep - 1);
  let previousLabel = previousStep ? `Back to ${previousStep.title.toLowerCase()}` : undefined;

  if (!previousHref && currentStep === 1 && options?.matterStatus) {
    if (!isPreDraftWizardStatus(options.matterStatus)) {
      previousHref = `/drafting/${matterId}`;
      previousLabel = "Back to draft";
    }
  }

  return {
    previousHref,
    previousLabel,
    nextHref: getDraftStepHref(matterId, currentStep + 1),
    nextLabel: nextStep ? `Continue to ${nextStep.title.toLowerCase()}` : undefined,
  };
}
